import { ModuleRunsView } from './ModuleRunsView';

/** Модуль «Добыча полезных ископаемых»: производственный отчёт + затраты,
 *  сверка объёмов и себестоимости тонны. Механика — см. ModuleRunsView. */
export function MiningReport() {
  return <ModuleRunsView moduleId="mining" />;
}
